import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";

import { Store } from "store";

import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";
import "rxjs/add/operator/filter";
import "rxjs/add/observable/of";

import { AuthService } from "../../../../auth/shared/services/auth/auth.service";

export interface Workout {
  name: string;
  type: string; // endurance | strength
  strength: any;
  endurance: any;
  timestamp: number;
  $key: string;
  $exists: () => boolean;
}

@Injectable()
export class WorkoutsService {
  // setup observable stream
  workouts$: Observable<Workout[]> = this.db
    .list(`workouts/${this.uid}`)
    .do(next => this.store.set("workouts", next));

  constructor(
    private store: Store,
    private db: AngularFireDatabase,
    private authService: AuthService
  ) {}

  // expose user id for string above
  get uid() {
    return this.authService.user.uid;
  }

  // get the key from the router. We are using this for the workout component for editing workouts
  // lookup id from the store
  getWorkout(key: string) {
    if (!key) return Observable.of({});
    return this.store
      .select<Workout[]>("workouts")
      .filter(Boolean)
      .map(workouts =>
        workouts.find((workout: Workout) => workout.$key === key)
      );
  }

  addWorkout(workout: Workout) {
    return this.db.list(`workouts/${this.uid}`).push(workout);
  }

  updateWorkout(key: string, workout: Workout) {
    return this.db.object(`workouts/${this.uid}/${key}`).update(workout);
  }

  // pass through the key to firebase to remove the workout
  removeWorkout(key: string) {
    return this.db.list(`workouts/${this.uid}`).remove(key);
  }
}



// WEBPACK FOOTER //
// ./src/health/shared/services/workouts/workouts.service.ts